// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__K4d8B","content":"styles_content__3Ne2R","checkbox":"styles_checkbox__2YHl-","checkboxLabel":"styles_checkboxLabel__2bNJZ"};